const TERMS = [
  {
    word: "爆料",
    def: "事件最初的信息发布行为，常由匿名信源或内部人提供。它只是起点，不等于已证实的事实。",
  },
  {
    word: "实锤",
    def: "被普遍认为难以反驳的强证据，通常有原始出处、可交叉验证。‘实锤’应谨慎使用，别随意扣帽子。",
  },
  {
    word: "反转",
    def: "事件出现与前期主流叙事相反的进展，常见于新证据或当事人澄清后，提醒读者勿过早下结论。",
  },
  {
    word: "辟谣",
    def: "对失实或未经证实的信息进行澄清。也需留意辟谣本身的信源，正规通报可信度更高。",
  },
  {
    word: "带节奏",
    def: "通过选择性呈现、情绪化措辞引导舆论朝向特定方向。识别它的最好办法是回到原始事实。",
  },
  {
    word: "通稿",
    def: "由机构或当事人统一对外发布的说明口径，信息较完整，但同样需要结合多方核对。",
  },
  {
    word: "石锤与锤",
    def: "网民对证据强度的一种通俗表达。锤得多不代表一定实，关键仍是出处与是否可验。",
  },
  {
    word: "下水/拱火",
    def: "形容在争议中被卷入或主动煽动对立的行为。旁观者应避免被卷入情绪化阵营。",
  },
];

export default function TermGridSection() {
  return (
    <section id="terms" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center" />
              05 · 术语速查
            </p>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              争议讨论里，那些高频词的真正意思
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
              看这类事件，总会碰到一堆黑话。把下面这些词弄明白，别人带节奏时，你就有了识别的底气。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {TERMS.map((t) => (
            <article
              key={t.word}
              className="bg-background-100 border border-background-200 rounded-lg p-5"
            >
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500" />
                <h3 className="font-label text-lg text-foreground-950">{t.word}</h3>
              </div>
              <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed">{t.def}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}